import type { CollectionColorEnum } from '@assembly-web/services';
import type { ChangeEvent } from 'react';

import { ColorRadioOption } from './ColorRadioOption';
import { EmojiPicker } from './EmojiPicker';
import { mapColorToCssClass } from './utils';

const colorOptions: CollectionColorEnum[] = [
  'grey',
  'blue',
  'red',
  'yellow',
  'green',
  'pink',
  'purple',
  'cyan',
  'orange',
];

export function EmojiColorPicker({
  color,
  emoji,
  onColorChange,
  onEmojiChange,
}: {
  color: CollectionColorEnum;
  emoji: string;
  onColorChange: (ev: ChangeEvent<HTMLInputElement>) => void;
  onEmojiChange: (emoji: string) => void;
}) {
  return (
    <div className="flex flex-row">
      <EmojiPicker
        emoji={emoji}
        onChange={onEmojiChange}
        buttonColor={mapColorToCssClass(color)}
      />
      <div className="ml-4 flex items-center">
        {colorOptions.map((colorOption) => (
          <ColorRadioOption
            checked={color === colorOption}
            color={colorOption}
            key={colorOption}
            onChange={onColorChange}
          />
        ))}
      </div>
    </div>
  );
}
